<template>
  <div v-if="loading" class="local-loading" :class="size">
    <i class="fa fa-circle-notch fa-spin" aria-hidden="true" />
    <br />
    <div v-if="text && !hideText" class="loading-text">{{ text }}</div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {translate} from "@/composables/i18n";

export default defineComponent({
  name: "LocalLoader",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: function () {
        return translate("general.loading");
      },
    },
    hideText: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "large",
    },
  },
});
</script>

<style lang="less" scoped>
.local-loading {
  text-align: center;
  i {
    font-size: 35px;
  }

  .loading-text {
    display: block;
    padding-top: 15px;
    font-size: 20px;
  }
}

.small {
  i {
    font-size: 20px;
  }

  .loading-text {
    font-size: 14px;
  }
}
</style>
